import React from 'react';

const MainFooter = (props) => {
  return <></>
}

export default MainFooter;